module.exports = __webpack_public_path__ + "static/media/bank11.b05bc2ad.png";